import { jsx as _jsx } from "react/jsx-runtime";
import ChevronRightIcon from "../../../icons/components/ChevronRightIcon.atom.js";
const iconSize = "12px";
export default {
    defaultProps: {
        separator: (_jsx(ChevronRightIcon, { sx: { width: iconSize, height: iconSize, color: ({ vars }) => vars.palette.primary.main } })),
    },
};
